import archiveNotifications from "./archiveNotifications";
import newNotifications from "./newNotifications";

export default [
    newNotifications,
    archiveNotifications,
]